var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('g', [_c('path', {
    attrs: {
      "d": "M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10Z",
      "opacity": ".4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15 10.75c-.72 0-1.25-.74-1.25-1.75s.53-1.75 1.25-1.75 1.25.74 1.25 1.75-.53 1.75-1.25 1.75ZM10.25 9c0-1.01-.53-1.75-1.25-1.75S7.75 7.99 7.75 9s.53 1.75 1.25 1.75 1.25-.74 1.25-1.75Zm-1.71 5c-.31 0-.54.28-.5.59A3.991 3.991 0 0 0 12 18c2.02 0 3.67-1.48 3.96-3.41a.514.514 0 0 0-.5-.59H8.54Z",
      "stroke": "#000000",
      "stroke-width": ".3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }